import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ApplyPipeModule } from '../../../takvim/apply.pipe';
import {
  DxSelectBoxModule,
  DxTextBoxModule,
  DxValidatorComponent,
  DxValidatorModule
} from 'devextreme-angular';
import { ContactStatusComponent } from '../contact-status/contact-status.component';
import { EditorStyle, ValidationRule } from 'devextreme/common';

@Component({
  selector: 'dk-password-textbox',
  standalone: true,
  imports: [CommonModule,
    ApplyPipeModule,
    DxSelectBoxModule,
    DxTextBoxModule,
    ContactStatusComponent,
    DxValidatorModule,
  ],
  templateUrl: './password-textbox.component.html',
  styleUrls: ['./password-textbox.component.scss'],
})
export class PasswordTextboxComponent {
  @ViewChild('validator', { static: true }) validator: DxValidatorComponent;

  
  @Input() value: string;

  @Input() placeholder = '';

  @Input() stylingMode: EditorStyle = 'outlined';

  @Input() validators: ValidationRule[] = [];

  @Output() valueChange = new EventEmitter<string>();

  @Output() valueChanged = new EventEmitter<string>();

  isPasswordMode = true;

  constructor() {
  }

  switchMode = () => {
    this.isPasswordMode = !this.isPasswordMode;
  }

  onValueChange(value:any) {
    this.value = value;
    this.valueChange.emit(value);
    this.valueChanged.emit(value);
  }

  revalidate() {
    this.validator?.instance.validate();
  }
}
